import { useNavigate } from "react-router-dom"
import { BASE_URL } from "../services/helper"

const Categories=({categories})=>{
    let navigate =useNavigate()
    return (
        categories?.map((category,index)=>(
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
            <a class="text-decoration-none" onClick={()=>navigate("/category/"+category.id)} >
                <div class="cat-item d-flex align-items-center mb-4">
                    <div class="overflow-hidden p-2" style={{width: "100px", height: "100px"}}>
                        <img height={"90px"}  src={BASE_URL+"images/categories/"+category.image} alt="category image" />
                    </div>
                    <div  class="flex-fill pl-3">
                        <h6>{category.name}</h6>
                        <small class="text-body">100 Products</small>
                    </div>
                </div>
            </a>
        </div>
        ))
    )
}

export default Categories